import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="terms-conditions">
      <div className="terms-container">
        <h1 className="terms-title">Sun King App – Terms and Conditions</h1>
        
        <div className="terms-content">
          <p>
            These Terms and Conditions ("Terms") govern your use of the Sun King mobile app ("App") for accessing and managing credit products offered by Sun King. By using the App, you agree to these Terms, our Privacy Policy, and any other agreements you enter into while applying for or using credit services through the App.
          </p>

          <h2>1. App Use and Eligibility</h2>
          <p>You must be at least 18 years old and legally capable of entering into contracts to use the App. Sun King may deny or revoke App access at any time for non-compliance, fraud, or misuse.</p>

          <h2>2. Credit Product Access via the App</h2>
          <p>Apply for new credit products (e.g., solar systems, loans)</p>
          <p>View your active product status and payment history</p>
          <p>Make mobile money payments</p>
          <p>Receive offers, notifications, and reminders</p>
          <p>All credit services are governed by individual loan or product agreements signed during onboarding.</p>

          <h2>3. Payments</h2>
          <p>You agree to make timely payments for any credit product accessed through the App. Missed payments may lead to:</p>
          <p>Service deactivation</p>
          <p>Ineligibility for new products or offers</p>
          <p>Reporting to credit bureaus (where applicable)</p>
          <p>Only digital mobile money payments through authorized methods are allowed. Cash payments are not supported through the App.</p>

          <h2>4. Offers and Promotions</h2>
          <p>Based on your app activity and repayment history, you may receive promotional offers like:</p>
          <p>New product unlocks</p>
          <p>Discounted upgrade plans</p>
          <p>Airtime or referral rewards</p>
          <p>All offers are time-limited and governed by additional terms.</p>

          <h2>5. Product Control and Deactivation</h2>
          <p>Products financed through the App may be remotely controlled by Sun King (e.g., activation, deactivation) based on your repayment status. Tampering with devices or software may result in permanent deactivation or legal action.</p>

          <h2>6. Account Responsibility</h2>
          <p>You are responsible for all actions taken on your App account. You must keep your contact and personal details up to date. Do not share your login credentials or verification codes with others.</p>

          <h2>7. Data Usage and Privacy</h2>
          <p>By using the App, you consent to Sun King collecting and processing your data for:</p>
          <p>Providing services</p>
          <p>Assessing eligibility</p>
          <p>Communicating offers or support</p>
          <p>Data may be shared with third-party service providers or credit bureaus as permitted by law. See our Privacy Policy for full details.</p>

          <h2>8. App Notifications</h2>
          <p>You agree to receive payment reminders, product alerts, and offers via App push notifications, SMS, or WhatsApp. You can manage notification settings, but critical messages may still be sent.</p>

          <h2>9. Fraud and Misuse</h2>
          <p>Fraudulent activity, such as providing false documents or tampering with devices, may lead to permanent bans, legal action, or reporting to authorities.</p>

          <h2>10. Limitation of Liability</h2>
          <p>Sun King is not liable for issues caused by third-party providers, phone issues, or uninstallation of the App.</p>

          <h2>11. Changes to Terms</h2>
          <p>We may update these Terms. Continued use of the App means you accept the revised Terms.</p>

          <h2>12. Governing Law</h2>
          <p>These Terms are governed by local law. Disputes will be resolved via Sun King's support or applicable legal procedures.</p>

          <p>By continuing to use the Sun King App, you confirm that you understand and agree to these Terms.</p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;